export const COMPANY = {
  name: "PUREGLASS",
  fullName: "PureGlass Witten",
  owner: "Malte Kühlenborg",
  tagline: "Fenster- & Rahmenreinigung",
  founded: "seit 2026",
  legalForm: "Einzelunternehmen",
  phone: "0152 0982 1038",
  phoneHref: "tel:+4915209821038",
  email: "info@pureglasswitten.de",
  emailHref: "mailto:info@pureglasswitten.de",
  street: "Südstraße 18",
  city: "58452 Witten",
  region: "Witten & Umgebung",
  hours: "Mo–Sa 8:00–20:00",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80",
  action: "https://images.unsplash.com/photo-1721620958961-cccc239cbb49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHx3aW5kb3clMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGdsYXNzJTIwc2NyYXBlcnxlbnwwfHx8fDE3ODkyNDU3NDJ8MA&ixlib=rb-4.1.0&q=85",
  wintergarten: "https://images.unsplash.com/photo-1759412393800-0ac06909423a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGNvbnNlcnZhdG9yeSUyMHdpbnRlcmdhcnRlbiUyMGdsYXNzJTIwaG91c2V8ZW58MHx8fHwxNzg5MjQ1NzQyfDA&ixlib=rb-4.1.0&q=85",
  tools: "https://images.unsplash.com/photo-1783587354828-9dcaed6af199?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHx3aW5kb3clMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbCUyMGdsYXNzJTIwc2NyYXBlcnxlbnwwfHx8fDE3ODkyNDU3NDJ8MA&ixlib=rb-4.1.0&q=85",
  home: "https://images.unsplash.com/photo-1605146769289-440113cc3d00?auto=format&fit=crop&w=1200&q=80",
  interior1: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1200&q=80",
  interior2: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=80",
  ba: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1600&q=80",
};

export const SERVICES = [
  {
    id: "fenster-privat",
    title: "Fensterreinigung Privat",
    audience: "privat",
    icon: "Home",
    price: "ab 6 € / Fenster",
    short: "Streifenfreie Fenster, Rahmen und Fensterbänke für Ihr Zuhause – auf Wunsch im regelmäßigen Intervall.",
    checklist: ["Glas beidseitig streifenfrei", "Rahmen inklusive", "Fensterbänke innen & außen", "Intervall-Service mit Erinnerung"],
  },
  {
    id: "fenster-gewerblich",
    title: "Fensterreinigung Gewerblich",
    audience: "gewerbe",
    icon: "Building2",
    price: "ab 6 € / Fenster",
    short: "Büros, Praxen und Gastronomie – zuverlässig außerhalb Ihrer Öffnungszeiten.",
    checklist: ["Glastüren & Eingangsbereiche", "Reinigung außerhalb der Öffnungszeiten", "Monatliches Festpreis-Abo", "Rahmen inklusive"],
  },
  {
    id: "wintergarten",
    title: "Wintergarten-Reinigung",
    audience: "privat",
    icon: "Sun",
    price: "ab 7 € / m²",
    short: "Komplette Glasdächer und Seitenflächen – inklusive Dachrinnen und schwer erreichbarer Profile.",
    checklist: ["Glasdach innen & außen", "Dachrinnen & Profile", "Verglasung komplett streifenfrei"],
  },
  {
    id: "schaufenster",
    title: "Schaufenster & Glastüren",
    audience: "gewerbe",
    icon: "Store",
    price: "ab 4 € / m²",
    short: "Ihr Aushängeschild immer einladend sauber – im flexiblen Wochen- oder Monatsintervall.",
    checklist: ["Wöchentliche oder monatliche Intervalle", "Glastüren & Eingangsbereich inklusive", "Fingerabdrücke & Anlaufen entfernt", "Reinigung vor Öffnungszeiten möglich"],
  },
];

export const CHAPTERS = [
  {
    nr: "01",
    title: "Präzision & Handwerk",
    text: "Als frisch gegründetes Einzelunternehmen aus Witten reinige ich jedes Fenster persönlich – mit der Sorgfalt eines Handwerkers, der mit seinem Namen für jedes Ergebnis einsteht.",
  },
  {
    nr: "02",
    title: "Rahmen immer inklusive",
    text: "Ein Fenster ist für uns erst sauber, wenn alles sauber ist: Rahmen, Beschläge und Fensterbänke gehören bei jeder Reinigung dazu – ohne Aufpreis. Das schont Ihre Fenster und verlängert ihre Lebensdauer.",
  },
  {
    nr: "03",
    title: "Festpreis-Transparenz",
    text: "Sie erhalten vor Beginn einen verbindlichen Festpreis. Keine versteckten Zuschläge, keine Überraschungen auf der Rechnung – das ist unser Versprechen seit dem ersten Tag.",
  },
  {
    nr: "04",
    title: "Zuverlässige Termintreue",
    text: "Feste Ansprechpartner, verbindliche Zeitfenster und automatische Erinnerungen bei Intervall-Aufträgen. Wenn wir einen Termin zusagen, stehen wir auch vor der Tür.",
  },
];

export const STATS = [
  { value: 100, suffix: " %", label: "Streifenfrei-Garantie" },
  { value: 24, suffix: " h", label: "Antwortzeit auf Anfragen" },
  { value: 5, suffix: " €", label: "Anfahrt in Witten" },
  { value: 1, suffix: "", label: "Persönlicher Ansprechpartner" },
];

export const PLANS = [
  {
    id: "privat",
    name: "Privat-Grundreinigung",
    price: "6 €",
    unit: "pro Fenster",
    testId: "pricing-plan-privat-button",
    features: ["Glas beidseitig streifenfrei", "Rahmen & Fensterbänke inklusive", "Festpreis vor Auftragsbeginn", "Mindestauftrag 50 €"],
  },
  {
    id: "gewerbe",
    name: "Gewerbe-Abo",
    price: "6 €",
    unit: "pro Fenster",
    featured: true,
    testId: "pricing-plan-gewerbe-button",
    features: ["Monatlicher Festpreis", "Reinigung außerhalb der Öffnungszeiten", "Fester Ansprechpartner", "Schaufenster & Glastüren inklusive"],
  },
  {
    id: "wintergarten",
    name: "Wintergarten-Reinigung",
    price: "7 €",
    unit: "pro m² Glasfläche",
    testId: "pricing-plan-wintergarten-button",
    features: ["Glasdach innen & außen", "Dachrinnen & Profile", "Ideal 2× pro Jahr"],
  },
];

export const GALLERY = [
  { src: IMAGES.action, caption: "Handarbeit im Detail", tag: "Privat" },
  { src: IMAGES.wintergarten, caption: "Wintergarten nach der Reinigung", tag: "Privat" },
  { src: IMAGES.interior1, caption: "Helle Räume, klare Fenster", tag: "Privat" },
];

export const MARQUEE_ITEMS = [
  "Fensterreinigung", "Wintergärten", "Schaufenster", "Rahmen inklusive", "Privat & Gewerblich",
];
